import { NotFound } from 'components';
import { useTranslation } from 'react-i18next';

export const AnonymousAppointment = () => {
  const { t } = useTranslation();
  return <NotFound text={t('anonymous.appointment.deprecatedText')} />;
};
